import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 7h6","key":"svg-0"}],["path",{"d":"M7 4v6","key":"svg-1"}],["path",{"d":"M20 18h-6","key":"svg-2"}],["path",{"d":"M5 19l14 -14","key":"svg-3"}]]

const IconPlusMinus = createReactComponent('outline', 'plus-minus', 'PlusMinus', __iconNode);

export default IconPlusMinus;